import React from 'react'
import PropTypes from 'prop-types'

const TabContainer = (props) => {
  const { children } = props
  return (
    <div className="tab-container">
      { children }
    </div>
  )
}

TabContainer.propTypes = { children: PropTypes.node.isRequired }

export default TabContainer
